export default __webpack_public_path__ + "static/media/mall-ico.a6f4b944.svg";